import {
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  UndoOutlined,
  UploadOutlined,
} from '@ant-design/icons'
import {
  Button,
  Divider,
  Flex,
  Form,
  Input,
  Modal,
  Radio,
  Row,
  Select,
  Upload,
} from 'antd'
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Swal from 'sweetalert2'
import {
  getBannerCategoryList,
  getBannerDetailButtonActionNameList,
  registerBanner,
} from '../../api/banner.api'
import { salusS3 } from '../../api/s3.api'
import ContentHeader from '../../components/shared/ContentHeader'
import '../../styles/banner.scss'
import {
  BANNER_CLICK_TYPE,
  BANNER_DETAIL_PAGE_JSON_EXAMPLE,
  BANNER_EXTERNAL_ROUTE_JSON_EXAMPLE,
  BANNER_INTERNAL_ROUTE_JSON_EXAMPLE,
} from '../../utils/banner'

const BannerRegisterPage = () => {
  const navigate = useNavigate()
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [previewVisible, setPreviewVisible] = useState(false)
  const [previewVisibleDetailPageImage, setPreviewVisibleDetailPageImage] =
    useState(false)
  const [localImage, setLocalImage] = useState(null)
  const [localImageFileObj, setLocalImageFileObj] = useState(null)
  const [localDetailPageImage, setLocalDetailPageImage] = useState(null)
  const [localDetailPageImageFileObj, setLocalDetailPageImageFileObj] =
    useState(null)
  const [showUpload, setShowUpload] = useState(false)
  const [uploadKey, setUploadKey] = useState(Date.now())
  const [uploadKeyDetailPageImage, setUploadKeyDetailPageImage] = useState(
    Date.now(),
  )
  const [newGeneratedDetailPageImageUrl, setNewGeneratedDetailPageImageUrl] =
    useState(null)
  const [navType, setNavType] = useState('')
  const [bannerCategoryList, setBannerCategoryList] = useState([])
  const [detailButtonActionNameList, setDetailButtonActionNameList] = useState(
    [],
  )
  const [detailPageActionType, setDetailPageActionType] = useState(null)
  const [detailPageActionName, setDetailPageActionName] = useState(undefined)
  const [isShow, setIsShow] = useState(true)
  const [contentType, setContentType] = useState('image')
  const [textContent, setTextContent] = useState('')

  const isImageUrl = (url) =>
    typeof url === 'string' && url.match(/\.(jpg|jpeg|png|gif|webp|svg)$/i)

  useEffect(() => {
    fetchBannerCategoryList()
    fetchBannerDetailButtonActionNameList()
    // eslint-disable-next-line
  }, [])

  const fetchBannerCategoryList = async () => {
    const res = await getBannerCategoryList()
    setBannerCategoryList(Array.isArray(res.data) ? res.data : [])
  }
  const fetchBannerDetailButtonActionNameList = async () => {
    const res = await getBannerDetailButtonActionNameList()
    setDetailButtonActionNameList(Array.isArray(res.data) ? res.data : [])
  }

  const saveAlert = () => {
    Swal.fire({
      text: '등록하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '등록',
      cancelButtonText: '취소',
    }).then((result) => {
      if (result.isConfirmed) {
        handleSave()
      }
    })
  }

  // S3 업로드
  const s3Upload = async (file) => {
    console.log('s3Upload file = ', file)
    let s3Path = `images/banner/new/${file.name}`
    let params = {
      Bucket: process.env.REACT_APP_S3_BUCKETNAME,
      Key: s3Path,
      Body: file,
    }
    let res = await salusS3.putObject(params).promise()
    console.log('s3Upload res = ', res)
    if (res.success === true) {
      return `https://sugarcoach-assets.s3.ap-northeast-2.amazonaws.com/${s3Path}`
    }
    return null
  }

  const handleSave = async () => {
    setLoading(true)
    const values = form.getFieldsValue()
    let newBannerS3Url = null
    if (contentType === 'text') {
      newBannerS3Url = textContent
    } else {
      if (localImageFileObj) {
        newBannerS3Url = await s3Upload(localImageFileObj)
      } else {
        newBannerS3Url = values.bannerImageUrl
      }
    }
    try {
      const params = {
        isShow,
        position: values.position,
        sortOrder: Number(values.sortOrder),
        bannerImageUrl: newBannerS3Url,
        imageUrl: newBannerS3Url,
        navigationType: values.navigationType,
        navigationPayload: values.navigationPayload,
        detailPageActionType: detailPageActionType,
        detailPageActionName: detailPageActionName,
        detailPageActionPayload: values.detailPageActionPayload,
        targetId: values.targetId,
        buttonText: values.buttonText,
      }
      await registerBanner(params)
      Modal.success({ title: '등록 완료', onOk: () => navigate(-1) })
    } catch (error) {
      Modal.error({ title: '등록 실패', content: error.message })
    } finally {
      setLoading(false)
    }
  }

  // 이미지 변경 버튼 클릭 시 업로드 모드로 전환
  const handleChangeImage = () => {
    setShowUpload(true)
    setLocalImage(null)
    setLocalImageFileObj(null)
  }
  const handleChangeImageToOriginal = () => {
    setShowUpload(false)
    setLocalImage(null)
    setLocalImageFileObj(null)
  }

  // antd Upload change 핸들러
  const handleUploadChange = (info) => {
    setLocalImage(null)
    setLocalImageFileObj(null)
    let file =
      info.file.originFileObj ||
      (info.fileList && info.fileList[0] && info.fileList[0].originFileObj)
    if (file) {
      setLocalImageFileObj(file)
      const reader = new FileReader()
      reader.onload = (ev) => {
        setLocalImage(ev.target.result)
      }
      reader.readAsDataURL(file)
      setUploadKey(Date.now())
    }
  }

  // 상세페이지 내부 이미지 업로드 핸들러 등 이하 BannerUpdatePage와 동일하게 복사...
  const handleUploadChangeDetailPageImage = (info) => {
    setLocalDetailPageImage(null)
    setLocalDetailPageImageFileObj(null)
    let file =
      info.file.originFileObj ||
      (info.fileList && info.fileList[0] && info.fileList[0].originFileObj)
    if (file) {
      setLocalDetailPageImageFileObj(file)
      const reader = new FileReader()
      reader.onload = (ev) => {
        setLocalDetailPageImage(ev.target.result)
      }
      reader.readAsDataURL(file)
      setUploadKeyDetailPageImage(Date.now())
    }
  }

  // ... 이하 BannerUpdatePage와 동일하게 구현 ...

  return (
    <div className="banner-update-container">
      <ContentHeader title="배너 등록" />
      <Form
        form={form}
        layout="vertical"
        initialValues={{ isShow: true, ...form.getFieldsValue() }}
        style={{
          maxWidth: 650,
          margin: '60px auto',
          padding: '0 20px',
          gap: 18,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <h2> 필수 정보</h2>
        <Link
          style={{
            marginBottom: 12,
            display: 'block',
            textDecoration: 'underline',
            fontSize: 16,
            fontWeight: 600,
          }}
          target="_blank"
          to="https://www.notion.so/23e203bac0ea801ca0acef7f11d4c194?source=copy_link"
        >
          📋 작성 가이드 보기
        </Link>
        <Row style={{ marginTop: 20, marginBottom: 18, alignItems: 'center' }}>
          <Form.Item
            label={
              <span
                style={{
                  fontWeight: 600,
                  fontSize: '1.05rem',
                  display: 'flex',
                  alignItems: 'center',
                  gap: 6,
                }}
              >
                노출 여부
              </span>
            }
            name="isShow"
            rules={[{ required: true }]}
          >
            <Radio.Group
              name="isShow"
              value={isShow}
              onChange={(e) => setIsShow(e.target.value)}
              optionType="button"
              buttonStyle="solid"
            >
              <Radio.Button value={true}>
                <EyeOutlined style={{ color: '#aaa', marginRight: 4 }} />
                노출
              </Radio.Button>
              <Radio.Button value={false}>
                <EyeInvisibleOutlined
                  style={{ color: '#aaa', marginRight: 4 }}
                />
                미노출
              </Radio.Button>
            </Radio.Group>
          </Form.Item>
        </Row>
        <Form.Item
          label="노출위치"
          name="position"
          rules={[{ required: true }]}
        >
          <Select
            options={bannerCategoryList.map((cat) => ({
              value: cat.key,
              label: cat.label,
            }))}
          />
        </Form.Item>
        <Form.Item
          label="정렬순서"
          name="sortOrder"
          rules={[{ required: true }]}
          min={1}
        >
          <Input type="number" />
        </Form.Item>
        <Form.Item
          label="배너 이미지/콘텐츠"
          name="bannerImageUrl"
          rules={[{ required: !localImage && !showUpload }]}
        >
          <Radio.Group
            value={contentType}
            onChange={(e) => setContentType(e.target.value)}
            style={{ marginBottom: 8 }}
          >
            <Radio.Button value="image">이미지로 관리</Radio.Button>
            <Radio.Button value="text">텍스트로 관리</Radio.Button>
          </Radio.Group>
          {contentType === 'image' ? (
            !showUpload ? (
              <>
                <div style={{ margin: '8px 0 16px 0' }}>
                  <div
                    style={{ display: 'inline-block', position: 'relative' }}
                  >
                    <img
                      src={form.getFieldValue('bannerImageUrl')}
                      alt="banner preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisible(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                </div>
                <Button onClick={handleChangeImage}>이미지 선택</Button>
              </>
            ) : (
              <>
                {(localImage || form.getFieldValue('bannerImageUrl')) && (
                  <div className="banner-preview-img-wrap">
                    <img
                      src={localImage || form.getFieldValue('bannerImageUrl')}
                      alt="local preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisible(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                )}
                <Flex gap={6}>
                  <Upload
                    key={uploadKey}
                    accept="image/*"
                    showUploadList={false}
                    beforeUpload={() => false}
                    onChange={handleUploadChange}
                    fileList={[]}
                    style={{ marginBottom: 8 }}
                  >
                    <Button icon={<UploadOutlined />}>이미지 업로드</Button>
                  </Upload>
                  <Button
                    icon={<UndoOutlined />}
                    onClick={handleChangeImageToOriginal}
                  >
                    초기화
                  </Button>
                </Flex>
              </>
            )
          ) : (
            <Input
              value={textContent}
              placeholder="텍스트 콘텐츠 입력"
              onChange={(e) => setTextContent(e.target.value)}
            />
          )}
        </Form.Item>
        <Form.Item
          label="이동타입"
          name="navigationType"
          rules={[{ required: true }]}
        >
          <Input.Group compact>
            <Select
              style={{ width: 200 }}
              options={Object.entries(BANNER_CLICK_TYPE).map(
                ([value, label]) => ({ value, label }),
              )}
              value={navType}
              onChange={(v) => {
                setNavType(v)
                form.setFieldValue('navigationType', v)
              }}
            />
            <Button
              icon={<CopyOutlined />}
              onClick={() => {
                const example = (() => {
                  switch (navType) {
                    case 'EXTERNAL_LINK':
                      return BANNER_EXTERNAL_ROUTE_JSON_EXAMPLE
                    case 'INTERNAL_ROUTE':
                      return BANNER_INTERNAL_ROUTE_JSON_EXAMPLE
                    case 'DETAIL_PAGE':
                      return BANNER_DETAIL_PAGE_JSON_EXAMPLE
                    default:
                      return ''
                  }
                })()
                if (example) {
                  navigator.clipboard.writeText(example)
                  Modal.success({ title: 'JSON 예시 복사 완료' })
                } else {
                  Modal.info({
                    title: '예시 없음',
                    content: '이동타입을 먼저 선택하세요.',
                  })
                }
              }}
            >
              예시 복사
            </Button>
          </Input.Group>
        </Form.Item>
        <Form.Item
          label="이동정보 (JSON)"
          name="navigationPayload"
          rules={[{ required: true }]}
        >
          <Input.TextArea rows={10} />
        </Form.Item>
        {navType === 'DETAIL_PAGE' && (
          <>
            <Divider />
            <h2 style={{ marginBottom: 20 }}>상세페이지 정의</h2>
            <Form.Item label="상세 페이지 이미지 주소 생성">
              <Upload
                key={uploadKeyDetailPageImage}
                accept="image/*"
                showUploadList={false}
                beforeUpload={() => false}
                onChange={handleUploadChangeDetailPageImage}
                fileList={[]}
              >
                <Button icon={<UploadOutlined />}>
                  {localDetailPageImage ? '이미지 변경' : '이미지 업로드'}
                </Button>
              </Upload>
              {localDetailPageImage && (
                <>
                  <div className="banner-preview-img-wrap">
                    <img
                      src={localDetailPageImage}
                      alt="local preview"
                      className="banner-preview-img"
                      onClick={() => setPreviewVisibleDetailPageImage(true)}
                    />
                    <span className="banner-preview-eye">
                      <EyeOutlined />
                    </span>
                  </div>
                  {newGeneratedDetailPageImageUrl && (
                    <p>
                      {newGeneratedDetailPageImageUrl}
                      <Button
                        onClick={() => {
                          navigator.clipboard.writeText(
                            newGeneratedDetailPageImageUrl,
                          )
                          Modal.success({ title: '이미지 주소 복사 완료' })
                        }}
                      >
                        복사
                      </Button>
                    </p>
                  )}
                  {!newGeneratedDetailPageImageUrl && (
                    <Button
                      onClick={async () => {
                        const imageUrl = await s3Upload(
                          localDetailPageImageFileObj,
                        )
                        setNewGeneratedDetailPageImageUrl(imageUrl)
                      }}
                    >
                      이미지 주소 생성하기
                    </Button>
                  )}
                </>
              )}
            </Form.Item>
            <Form.Item label="버튼 사용 여부">
              <Radio.Group
                value={detailPageActionType}
                onChange={(e) => {
                  setDetailPageActionType(e.target.value)
                  form.setFieldValue('detailPageActionType', e.target.value)
                }}
              >
                <Radio value="BUTTON">버튼 사용</Radio>
                <Radio value={null}>버튼 없음</Radio>
              </Radio.Group>
            </Form.Item>
            {detailPageActionType === 'BUTTON' && (
              <>
                <Form.Item
                  label="버튼 클릭 액션 유형"
                  name="detailPageActionName"
                  rules={[{ required: true }]}
                >
                  <Select
                    value={detailPageActionName}
                    onChange={(v) => {
                      setDetailPageActionName(v)
                      form.setFieldValue('detailPageActionName', v)
                    }}
                    options={detailButtonActionNameList.map((item) => ({
                      value: item.key,
                      label: item.label,
                    }))}
                    allowClear
                  />
                </Form.Item>
                <Form.Item
                  label="버튼 텍스트"
                  name="buttonText"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
                {detailPageActionName !== 'NAVIGATION' && (
                  <Form.Item
                    rules={[{ required: true }]}
                    label={
                      detailPageActionName === 'LINK'
                        ? '외부 링크 주소'
                        : '발급 쿠폰 코드'
                    }
                    name="targetId"
                  >
                    <Input />
                  </Form.Item>
                )}
                {detailPageActionName === 'NAVIGATION' && (
                  <>
                    <Form.Item
                      label="상세 페이지 이동 정보(JSON)"
                      name="detailPageActionPayload"
                      rules={[{ required: true }]}
                    >
                      <Input.TextArea rows={10} />
                    </Form.Item>
                    <Button
                      icon={<CopyOutlined />}
                      onClick={() => {
                        navigator.clipboard.writeText(
                          BANNER_INTERNAL_ROUTE_JSON_EXAMPLE,
                        )
                        Modal.success({ title: 'JSON 예시 복사 완료' })
                      }}
                    >
                      예시 복사
                    </Button>
                  </>
                )}
              </>
            )}
          </>
        )}
      </Form>
      <div className="banner-update-fixed-footer">
        <Button
          type="primary"
          htmlType="submit"
          loading={loading}
          onClick={saveAlert}
          disabled={loading}
        >
          등록
        </Button>
        <Button style={{ marginLeft: 8 }} onClick={() => navigate(-1)}>
          취소
        </Button>
      </div>
      <Modal
        width={window.innerWidth * 0.6}
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img
          src={localImage || form.getFieldValue('bannerImageUrl')}
          alt="banner"
          style={{ width: '100%' }}
        />
      </Modal>
      <Modal
        width={window.innerWidth * 0.6}
        open={previewVisibleDetailPageImage}
        footer={null}
        onCancel={() => setPreviewVisibleDetailPageImage(false)}
        centered
      >
        <img
          src={localDetailPageImage}
          alt="banner"
          style={{ width: '100%' }}
        />
      </Modal>
    </div>
  )
}

export default BannerRegisterPage
